<script setup lang="ts">
    type LocalizedLinkItem = { to: string; country?: string; lang?: string };

    const { localizedLinks } = defineProps<{ localizedLinks: LocalizedLinkItem[] }>();

    const ambiguousLinks = computed(() => {
        const links = localizedLinks.reduce(
            (acc, link) => {
                const key = `${link?.country}-${link?.lang}`;
                if (acc[key]) {
                    acc[key].push(link.to);
                } else {
                    acc[key] = [link.to];
                }
                return acc;
            },
            {} as Record<string, string[]>
        );

        return Object.entries(links).filter(([_, value]) => value.length > 1);
    });
</script>

<template>
    <Note
        v-if="ambiguousLinks.length > 0"
        type="error"
        class="note"
    >
        <p>There are ambiguous links: Please fix them before publishing.</p>
        <div
            v-for="[key, value] in ambiguousLinks"
            :key="key"
        >
            <strong>{{ key }}</strong>
            <ul
                v-for="link in value"
                :key="link"
            >
                <li>{{ link }}</li>
            </ul>
        </div>
    </Note>
</template>

<style scoped lang="scss">
    .note {
        margin: var(--spacing--2);
        max-width: 100%;
        width: auto;
    }
</style>
